// @ts-nocheck
import { SPELLS } from "../../data";
import { Particle } from "../../entities";
import { TAU, clamp, rand, rgba } from "../../util";
import { Game } from "../game-base";

Game.IW_LIGHT_ANG = Math.PI * 1.25;
Game.IW_COLLAPSE_DUR = 0.85;

Game.prototype.iceWallAng = function (w) {
  return (w.dx || w.dy) ? Math.atan2(w.dy, w.dx) : 0;
};

Game.prototype.iceWallPoint = function (w, lx, ly) {
  const a = this.iceWallAng(w);
  const tx = -Math.sin(a);
  const ty = Math.cos(a);
  return {
    x: w.x + lx * Math.cos(a) + ly * tx,
    y: w.y + lx * Math.sin(a) + ly * ty,
  };
};

Game.prototype.iceWallHash = function (n, seed) {
  const s = Math.sin(n * 12.9898 + seed * 78.233) * 43758.5453;
  return s - Math.floor(s);
};

Game.prototype.iceWallSeed = function (w) {
  return w.x * 12.9898 + w.y * 78.233;
};

// 0 = solid; near expiry crack → sink inward → fade out.
Game.prototype.iceWallCollapse = function (w) {
  const life = w.life;
  if (life == null || life > Game.IW_COLLAPSE_DUR) {
    return { active: false, crack: 0, fall: 0, alpha: 1 };
  }
  const prog = 1 - life / Game.IW_COLLAPSE_DUR;
  const crack = clamp(prog / 0.42, 0, 1);
  const fallRaw = clamp((prog - 0.18) / 0.62, 0, 1);
  const fall = fallRaw * fallRaw * (3 - 2 * fallRaw);
  const alpha = 1 - clamp((prog - 0.48) / 0.52, 0, 1);
  return { active: true, crack, fall, alpha };
};

Game.prototype.iceWallBoulders = function (w, hy, seed) {
  const hx = w.hx || 68;
  const n = 3 + Math.floor(this.iceWallHash(0, seed) * 2);
  const out = [];
  for (let i = 0; i < n; i++) {
    const t = (i + 0.5) / n;
    const lx = -hx * 0.88 + t * hx * 1.76;
    const ly = (this.iceWallHash(i + 3, seed) - 0.5) * hy * 0.38;
    const pt = this.iceWallPoint(w, lx, ly);
    const r = hy * (0.62 + this.iceWallHash(i + 7, seed) * 0.42);
    out.push({ x: pt.x, y: pt.y, r, seed: seed + i * 17.3 });
  }
  return out;
};

Game.prototype.drawIceBoulderCracks = function (fp, capH, r, seed, crack) {
  if (crack <= 0.02) return;
  const c = this.ctx;
  const jit = (i) => this.iceWallHash(i, seed);
  const nCracks = 3 + Math.floor(jit(80) * 4);
  c.save();
  c.lineCap = "round";
  c.lineJoin = "round";
  for (let ci = 0; ci < nCracks; ci++) {
    const vi = Math.floor(jit(ci + 90) * fp.length);
    const p = fp[vi];
    let x = p.x * (0.25 + 0.55 * jit(ci + 91));
    let y = p.y - capH[vi] * (0.35 + 0.45 * jit(ci + 92));
    let dir = jit(ci + 93) * TAU;
    c.beginPath();
    c.moveTo(x, y);
    const segs = 3 + Math.floor(jit(ci + 94) * 4);
    for (let s = 0; s < segs; s++) {
      dir += (jit(ci + s + 95) - 0.5) * 1.5;
      const step = r * (0.07 + 0.14 * jit(ci + s + 96)) * crack;
      x += Math.cos(dir) * step;
      y += Math.sin(dir) * step;
      c.lineTo(x, y);
    }
    c.strokeStyle = rgba("#061018", 0.62 * crack);
    c.lineWidth = 1.4 + 1.8 * crack;
    c.stroke();
    c.strokeStyle = rgba("#e8fbff", 0.32 * crack);
    c.lineWidth = 0.55;
    c.stroke();
  }
  c.restore();
};

Game.prototype.drawIceBoulder = function (x, y, r, seed, col, collp) {
  collp = collp || { crack: 0, fall: 0, alpha: 1, lean: 0 };
  if (collp.alpha <= 0.02) return;
  const c = this.ctx;
  const inv = this.scale / this.scaleY;
  const lcx = Math.cos(Game.IW_LIGHT_ANG);
  const lcy = Math.sin(Game.IW_LIGHT_ANG);
  const jit = (i) => this.iceWallHash(i, seed);
  const shrink = 1 - collp.fall * 0.2;
  const H = r * (0.78 + jit(99) * 0.22) * inv * shrink * (1 - collp.fall * 0.45);
  const N = 11;
  const fp = [];
  const capH = [];
  for (let i = 0; i < N; i++) {
    const a = (i / N) * TAU + (jit(i + 40) - 0.5) * 0.55;
    const rr = r * shrink * (0.52 + 0.48 * jit(i));
    fp.push({ x: Math.cos(a) * rr, y: Math.sin(a) * rr });
    capH.push(H * (0.82 + 0.75 * jit(i + 20)));
  }

  c.save();
  c.globalAlpha = collp.alpha;
  c.translate(x, y);
  c.rotate(collp.lean * collp.fall);
  c.translate(0, collp.fall * r * 0.42);

  c.fillStyle = "rgba(6,16,28,0.32)";
  c.beginPath();
  c.ellipse(r * 0.28, r * 0.32, r * 1.08 * shrink, r * 0.62 * shrink, 0, 0, TAU);
  c.fill();

  for (let i = 0; i < N; i++) {
    const p = fp[i], q = fp[(i + 1) % N];
    const hi = capH[i], hj = capH[(i + 1) % N];
    let nx = q.y - p.y, ny = -(q.x - p.x);
    const nl = Math.hypot(nx, ny) || 1;
    nx /= nl; ny /= nl;
    if (ny < -0.05) continue;
    const my = (p.y + q.y) * 0.5;
    c.beginPath();
    c.moveTo(p.x, p.y - hi);
    c.lineTo(q.x, q.y - hj);
    c.lineTo(q.x, p.y);
    c.lineTo(p.x, p.y);
    c.closePath();
    const g = c.createLinearGradient(0, my - hi, 0, my + r * 0.25);
    g.addColorStop(0, rgba("#7ec8e8", 0.38));
    g.addColorStop(0.45, rgba(col, 0.32));
    g.addColorStop(1, rgba("#142838", 0.58));
    c.fillStyle = g;
    c.fill();
    const o = nx * lcx + ny * lcy;
    c.fillStyle = o >= 0
      ? `rgba(220,248,255,${o * 0.18})`
      : `rgba(4,12,24,${-o * 0.35})`;
    c.fill();
  }

  const capPath = () => {
    c.beginPath();
    for (let i = 0; i < N; i++) {
      const p = fp[i];
      if (i) c.lineTo(p.x, p.y - capH[i]);
      else c.moveTo(p.x, p.y - capH[i]);
    }
    c.closePath();
  };

  capPath();
  const tg = c.createRadialGradient(-r * 0.34, -r * 0.42 - H, r * 0.08, 0, -H, r * 1.25);
  tg.addColorStop(0, rgba("#e8fbff", 0.52));
  tg.addColorStop(0.45, rgba(col, 0.42));
  tg.addColorStop(1, rgba("#2a5878", 0.48));
  c.fillStyle = tg;
  c.fill();

  for (let i = 0; i < N; i++) {
    const p = fp[i], q = fp[(i + 1) % N];
    const dx = (p.x + q.x) * 0.5, dy = (p.y + q.y) * 0.5;
    const dl = Math.hypot(dx, dy) || 1;
    const o = (dx / dl) * lcx + (dy / dl) * lcy;
    c.beginPath();
    c.moveTo(0, -H * 0.55);
    c.lineTo(p.x, p.y - capH[i]);
    c.lineTo(q.x, q.y - capH[(i + 1) % N]);
    c.closePath();
    c.fillStyle = o >= 0
      ? `rgba(240,252,255,${o * 0.14})`
      : `rgba(4,10,20,${-o * 0.16})`;
    c.fill();
  }

  for (let i = 0; i < N; i++) {
    if (capH[i] < H * 1.05) continue;
    const p = fp[i];
    const prev = fp[(i + N - 1) % N];
    const next = fp[(i + 1) % N];
    const tipY = p.y - capH[i] - r * shrink * (0.18 + jit(i + 60) * 0.28) * (1 - collp.fall * 0.7);
    c.beginPath();
    c.moveTo(prev.x * 0.55 + p.x * 0.45, prev.y * 0.55 + p.y * 0.45 - capH[(i + N - 1) % N] * 0.45);
    c.lineTo(p.x, tipY);
    c.lineTo(next.x * 0.55 + p.x * 0.45, next.y * 0.55 + p.y * 0.45 - capH[(i + 1) % N] * 0.45);
    c.closePath();
    c.fillStyle = rgba("#d8f4ff", 0.35);
    c.fill();
    c.strokeStyle = rgba("#f4fdff", 0.45);
    c.lineWidth = 1.2;
    c.stroke();
  }

  this.drawIceBoulderCracks(fp, capH, r, seed, collp.crack);

  capPath();
  c.lineJoin = "round";
  c.lineWidth = 2;
  c.strokeStyle = "rgba(8,20,36,0.45)";
  c.stroke();
  c.lineWidth = 1.5;
  c.strokeStyle = rgba("#e8fbff", 0.35);
  c.beginPath();
  let lipOn = false;
  for (let i = 0; i <= N; i++) {
    const p = fp[i % N];
    const a = (i / N) * TAU;
    const toward = Math.cos(a) * lcx + Math.sin(a) * lcy;
    if (toward > 0.08) {
      if (lipOn) c.lineTo(p.x, p.y - capH[i % N]);
      else { c.moveTo(p.x, p.y - capH[i % N]); lipOn = true; }
    } else lipOn = false;
  }
  c.stroke();

  c.restore();
};

Game.prototype.updateIceWallCollapse = function (dt) {
  const active = this.state === "playing" || this.state === "countdown";
  if (!active) return;
  for (const w of this.icewalls) {
    const col = this.iceWallCollapse(w);
    if (!col.active) {
      w._shardAcc = 0;
      continue;
    }
    const hy = w.hy || 38;
    const seed = this.iceWallSeed(w);
    const boulders = this.iceWallBoulders(w, hy, seed);
    w._shardAcc = (w._shardAcc || 0) + dt * (6 + 36 * col.fall) * (0.35 + 0.65 * col.crack);
    while (w._shardAcc >= 1) {
      w._shardAcc -= 1;
      if (Math.random() > col.fall * 0.75 + col.crack * 0.35) continue;
      const b = boulders[Math.floor(Math.random() * boulders.length)];
      const inv = this.scale / this.scaleY;
      const topY = b.y - b.r * inv * 0.85;
      this.particles.push(new Particle(
        b.x + rand(-b.r * 0.45, b.r * 0.45),
        topY + rand(-b.r * 0.1, b.r * 0.15),
        rand(-40, 40), rand(30, 110),
        rand(0.3, 0.65),
        Math.random() < 0.45 ? "#e8fbff" : "#8fdcff",
        rand(1.8, 4.5),
        { kind: "spark", grav: 220, drag: 0.93 },
      ));
    }
  }
};

Game.prototype.drawIceWallMass = function (w) {
  const col = (SPELLS.glacier || {}).color || "#8fdcff";
  const hy = w.hy || 38;
  const seed = this.iceWallSeed(w);
  const collp = this.iceWallCollapse(w);
  if (collp.alpha <= 0.02) return;
  const boulders = this.iceWallBoulders(w, hy, seed);
  const pull = collp.fall * 0.22;
  const sorted = boulders.slice().sort((a, b) => a.y - b.y);
  for (const b of sorted) {
    const lean = (this.iceWallHash(200, b.seed) - 0.5) * 0.14;
    const x = b.x + (w.x - b.x) * pull;
    const y = b.y + (w.y - b.y) * pull * 0.35;
    this.drawIceBoulder(x, y, b.r, b.seed, col, { ...collp, lean });
  }
};

Game.prototype.drawIceWalls = function () {
  const c = this.ctx;
  for (const w of this.icewalls) {
    const hy = w.hy || 38;
    const seed = this.iceWallSeed(w);
    const collp = this.iceWallCollapse(w);
    if (collp.alpha <= 0.02) continue;
    const pull = collp.fall * 0.22;
    for (const b of this.iceWallBoulders(w, hy, seed)) {
      const x = b.x + (w.x - b.x) * pull;
      const y = b.y + (w.y - b.y) * pull * 0.35;
      c.save();
      c.globalAlpha = 0.35 * collp.alpha;
      c.fillStyle = "rgba(4,12,22,0.5)";
      c.beginPath();
      c.ellipse(x + b.r * 0.25, y + b.r * 0.28 + collp.fall * b.r * 0.35, b.r * 1.1, b.r * 0.55, 0, 0, TAU);
      c.fill();
      c.restore();
    }
  }
};

Game.prototype.drawIceWallMasses = function () {
  for (const w of this.icewalls) this.drawIceWallMass(w);
};
